import AppSettings from '../AppSettings';
// Librairies
import Axios from 'axios';
import Cookies from 'universal-cookie';

const BACKEND_ENDPOINT = AppSettings.getBackendUrl();

export default class ParametersService {
    static getVersions() {
        // 8 s au plus : au-delà, App reprend les versions locales
        return Axios.get(BACKEND_ENDPOINT + 'parameters/versions/', { timeout: 8000 }).then(response => {
            return response.data;
        }, error => { return; });
    }

    // Organisations du pilote du hors-ligne ; undefined si l'API ne répond pas
    static getOfflinePilot() {
        return Axios.get(BACKEND_ENDPOINT + 'parameters/offlinePilot', {
            headers: { 'Authorization': `Bearer ${new Cookies().get('token')}` },
            timeout: 8000
        }).then(response => {
            return response.data;
        }, () => { return; });
    }

    static toggleMaintenanceStatus(status) {
        return Axios.get(BACKEND_ENDPOINT + 'admin/parameters/toggleMaintenanceStatus/?isUnderMaintenance=' + status, {
            headers: { 'Authorization': `Bearer ${new Cookies().get('token')}` }
        }).then(response => {
            return response.status;
        }, () => {
            return;
        });
    }
}